// react
import React, { useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { MaskMonthYear, transformValueFloattoFormated  } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioAnaliticoFechamento() {
    const { t } = useTranslation();

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
   
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => {
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    useEffect(() => {
        let mesano = moment(new Date()).format('MM/YYYY');
        setValue('mesano', mesano); 

        verifyAcess();
    }, []);

    const verifyAcess = () =>{
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            listSelectEstabelecimentosSelected([{estabelecimentoId:session.estabelecimentoId}]);
            setshowSelectEstabelecimentos(false)
        }
    }          

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
    const LoadEstabelecimentos = () =>{
        setloadingSelectEstabelecimentos(true);   
        let endPointE = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPointE).then(result=>{      
            if(result.status !== 200)
            {                                     
                showNotification(t('error_message.the_establishments_could_not_be_loaded'),'danger'); 
                setloadingSelectEstabelecimentos(false); 
                return false; 
            }     
            setlistSelectEstabelecimentos(result.data);  
            setloadingSelectEstabelecimentos(false); 
            return true;                
        });  
    }
    const handleEstabelecimentoChange = event => {
        let value = event
        let data = getValues()

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId:item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);

    }
    const handleClickSelecionarTodosEstabelecimentos = () =>{
        
        let data = getValues()
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);
    }
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if (listSelectEstabelecimentosSelected.length === 0)
            return setError("estabelecimentos", "required")
        else
            clearError("estabelecimentos")

        if(data.mesano === "")
        {
            setError("mesano","required", t('label.required'))
            return false;
        }
        else
            clearError("mesano")
        
        if (!moment(data.mesano, 'MM/YYYY',true).isValid()) {
            setError("mesano", "invaliddate",  t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("mesano")

        let obj = {
            estabelecimentos: listSelectEstabelecimentosSelected,
            mesAno:data.mesano
        }
        loadDados(obj);
    };

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) =>{
        setisLoadingList(true);       
        const endPoint = "relatorios/relanaliticofechamento/";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }                
            setlist(result.data);

            let dataCSV =[];

            result.data.map(item =>{
                var obj = {
                    estabelecimentoDescricao: item.estabelecimentoDescricao,
                    valorFaturamentoTotal: "R$" + transformValueFloattoFormated(item.valorFaturamentoTotal),
                    valorFaturamentoPacotesServicos: "R$" + transformValueFloattoFormated(item.valorFaturamentoPacotesServicos),
                    valorFaturamentoProdutos: "R$" + transformValueFloattoFormated(item.valorFaturamentoProdutos),
                    mediaParcelas: item.mediaParcelas,
                    valorRepasseSliptCartaoClinica: "R$" + transformValueFloattoFormated(item.valorRepasseSliptCartaoClinica),
                    valorCreditosAVista: "R$" + transformValueFloattoFormated(item.valorCreditosAVista),
                    valorCreditosFechamento: "R$" + transformValueFloattoFormated(item.valorCreditosFechamento),
                    valorDebitos: "R$" + transformValueFloattoFormated(item.valorDebitos),
                    valorAPagar: "R$" + transformValueFloattoFormated(item.valorAPagar),
                    saldoDevedorRemanescente: "R$" + transformValueFloattoFormated(item.saldoDevedorRemanescente ? item.saldoDevedorRemanescente : 0)
                };
                dataCSV.push(obj);
            })

            loadDataCsv(dataCSV);
            setisLoadingList(false);   
            return true;                
        });  
    }

    const columnsProp = [
        {
            Header: t('label.establishment'),
            filterable: false,
            accessor: "estabelecimentoDescricao",
        },
        {
            Header: t('reports.money_s_Billing'),
            filterable: false,
            accessor: "valorFaturamentoTotal",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('reports.money_s_package_service'),
            filterable: false,
            accessor: "valorFaturamentoPacotesServicos",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('reports.money_s_product'),
            filterable: false,
            accessor: "valorFaturamentoProdutos",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('reports.average_parcel'),
            filterable: false,
            accessor: "mediaParcelas"
        },
        {
            Header: t('reports.money_s_onlending_slipt'),
            filterable: false,
            // Nome da propriedade na API (ExtratoRoyaltieDto) é "Slipt"
            accessor: "valorRepasseSliptCartaoClinica",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('reports.money_s_credits_sight'),
            filterable: false,
            accessor: "valorCreditosAVista",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('reports.money_s_credits_closing'),
            filterable: false,
            accessor: "valorCreditosFechamento",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('reports.money_s_debits'),
            filterable: false,
            accessor: "valorDebitos",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('reports.money_s_to_pay'),
            filterable: false,
            accessor: "valorAPagar",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
        },
        {
            // Regra V2: saldo que a antecipação automática não cobriu e foi transportado como dívida ao mês seguinte
            Header: t('reports.money_s_carried_debt'),
            filterable: false,
            accessor: "saldoDevedorRemanescente",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
        }
    ]

    const columns = [...columnsProp]

    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        {id: 'estabelecimentoDescricao', displayName: 'Estabelecimento'}, 
        {id: 'valorFaturamentoTotal', displayName: 'Faturamento Total'}, 
        {id: 'valorFaturamentoPacotesServicos', displayName: 'Faturamento Pacote e Serviço'}, 
        {id: 'valorFaturamentoProdutos', displayName: 'Valor Produto'},
        {id: 'mediaParcelas', displayName: 'Média Parcelas'},
        {id: 'valorRepasseSliptCartaoClinica', displayName: 'Valor Repasse Split Cartão'},
        {id: 'valorCreditosAVista', displayName: 'Creditos a Vista'}, 
        {id: 'valorCreditosFechamento', displayName: 'Creditos Fechamento'}, 
        {id: 'valorDebitos', displayName: 'Debitos'}, 
        {id: 'valorAPagar', displayName: 'Valor a Pagar'},
        {id: 'saldoDevedorRemanescente', displayName: 'Saldo Devedor Transportado'}
    ];
    const loadDataCsv = (data) =>{        
        setdataCSV(data);
    } 

    const classes = useStyles();
    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('reports.closing_analytical_report')}</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>
                                {showSelectEstabelecimentos &&
                                <GridItem xs={12} sm={12} md={12}>
                                <FormControl fullWidth className={classes.formControl}>  
                        
                                <label className={errors.estabelecimentos?"select__label select__label_error":"select__label"}>
                                    {t('label.establishments')}  </label>
                                <Select
                                    classNamePrefix="select"  
                                    isSearchable={true}
                                    styles={ValidSelect(errors.estabelecimentos?true:false)} 
                                    placeholder={t('label.select')+"..."}
                                    isMulti={true}    
                                    name="estabelecimentos"                                  
                                    isLoading={loadingSelectEstabelecimentos}
                                    options={listSelectEstabelecimentos}     
                                    getOptionLabel={({descricao}) => descricao}
                                    getOptionValue={({estabelecimentoId}) => estabelecimentoId} 
                                    value={listSelectEstabelecimentos.filter(({estabelecimentoId}) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                    onChange={(value) => handleEstabelecimentoChange(value || [])}                                      
                                    ref={() => register( { name: "estabelecimentos" }) }
                                />
                                {errors.estabelecimentos &&
                                    <FormHelperText>
                                        <span className="obg"> {t('label.required')} </span>
                                    </FormHelperText>}
                                
                                    <div style={{textAlign:'right',marginTop:'3px'}}>
                                <a href="#"  onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{marginTop:'10px'}}>
                                     {t('label.select_all_establishments')}
                                </a></div>
                        
                                </FormControl> 
                        
                                </GridItem>}          
                                <GridItem xs={12} sm={4} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>   
                                    <TextField          
                                        variant="outlined"   
                                        InputLabelProps={{shrink: true}}                  
                                        label={t('label.month_year')+" *"}                                                         
                                        name="mesano"        
                                        inputRef={register({required: t('label.required')})}  
                                        error={errors.mesano?true:false}  
                                        defaultValue={''}                                       
                                        InputProps={{ inputComponent: MaskMonthYear }}   
                                    />
                                    {errors.mesano &&<FormHelperText className={classes.labelRootError}>
                                        <span> {errors.mesano.message} </span>
                                    </FormHelperText> }  
                                    </FormControl>  
                                </GridItem> 
                                <GridItem xs={12} sm={6} md={2}>
                                <Button  round color="primary" 
                                    onClick={e => { handleClickPesquisa()}}>
                                    {t('button.search')} 
                                </Button>
                                </GridItem>
                                
                                {notification.show &&
                                <div><br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                /></div>}
                            </GridContainer>   

                            
                            {dataCSV.length > 0 &&
                                <div>
                                    <div style={{float:'right'}}>
                                    <CsvDownloader
                                    filename="report"
                                    columns={columnsCSV}
                                    datas={dataCSV}
                                    separator={";"}>
                                        <Button  round color="default" size="sm" >CSV</Button> 
                                    </CsvDownloader>
                                    </div><div style={{clear:'both'}}></div>
                                </div>
                            }
                            <div style={{overflowX:'auto',width:'100%'}}>
                            <div style={{minWidth:'1800px'}}>                    
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                columns={columns}
                                minRows={5}
                                //defaultPageSize={10}
                                showPagination={false}
                                pageSize={list.length}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                            </div>
                            </div>    
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
        </div>
    );
}
